import { Observable } from 'rxjs'
import { StateObservable, ofType } from 'redux-observable'
import { map } from 'rxjs/operators'
import { GlobalState } from 'store'
import { SelectionActions, SelectionActionTypes } from 'store/selection'
import { BTQAction } from 'epics'

type SetPrepareStagingOrdersAction = ReturnType<typeof SelectionActions.setPreparedStagingOrders>
type UnprepareStagingAllAction = ReturnType<typeof SelectionActions.unprepareStagingAll>

export function collectionPrepareEpic(action$: Observable<BTQAction>, _state$: StateObservable<GlobalState>): Observable<BTQAction> {
  return action$.pipe(
    ofType<
      BTQAction,
      SelectionActionTypes.SET_PREPARED_STAGING_ORDERS | SelectionActionTypes.UNPREPARE_STAGING_ALL,
      SetPrepareStagingOrdersAction | UnprepareStagingAllAction
    >(SelectionActionTypes.SET_PREPARED_STAGING_ORDERS, SelectionActionTypes.UNPREPARE_STAGING_ALL),
    map(action => {
      if (action.type === SelectionActionTypes.SET_PREPARED_STAGING_ORDERS) {
        const { preparedStagingOrders, windowId } = action.payload

        if (preparedStagingOrders.length === 0) {
          return SelectionActions.setPreparedCollectionId(null, windowId)
        }

        const firstOrderCollectionId = preparedStagingOrders[0].orderDetail.order.collectionId

        if (
          preparedStagingOrders.some(preparedStagingOrder => preparedStagingOrder.orderDetail.order.collectionId !== firstOrderCollectionId)
        ) {
          // Selected orders must all belong to the same collection or no collection
          return SelectionActions.setPreparedCollectionId(null, windowId)
        }

        return SelectionActions.setPreparedCollectionId(firstOrderCollectionId, windowId)
      } else {
        return SelectionActions.setPreparedCollectionId(null, action.payload.windowId)
      }
    })
  )
}
